import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=36d96522&"
import script from "./PaymentGateway.vue?vue&type=script&lang=js&"
export * from "./PaymentGateway.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d96522')) {
      api.createRecord('36d96522', component.options)
    } else {
      api.reload('36d96522', component.options)
    }
    module.hot.accept("./PaymentGateway.vue?vue&type=template&id=36d96522&", function () {
      api.rerender('36d96522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/PaymentGateway.vue"
export default component.exports